import React, { useState, useRef, useEffect } from 'react';
import './StockandEdit.scss';
import { FiEdit2, FiTrash2 } from 'react-icons/fi';
import EditProduct from './../EditProduct/EditProduct.jsx';

const initialProducts = [
  {
    id: '#232132135612',
    name: 'E-marketing A1',
    category: 'Social media',
    quantity: '20/11',
    price: 'EGP.120,000.00',
    status: 'unavailable',
  },
  {
    id: '#232132135613',
    name: 'E-marketing A2',
    category: 'Social media',
    quantity: '20/11',
    price: 'EGP.120,000.00',
    status: 'Sold out',
  },
  {
    id: '#232132135614',
    name: 'E-marketing B1',
    category: 'Social media',
    quantity: '20/11',
    price: 'EGP.120,000.00',
    status: 'In stock',
  },
];

const statusColors = {
  'unavailable': 'unavailable',
  'Sold out': 'soldout',
  'In stock': 'instock',
  'Limited': 'limited',
};

export default function StockandEdit() {
  const [openedDropdown, setOpenedDropdown] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editProductData, setEditProductData] = useState(null);
  const dotsRefs = useRef([]);

  useEffect(() => {
    function handleClickOutside(event) {
      dotsRefs.current.forEach((ref, idx) => {
        if (ref && !ref.contains(event.target)) {
          if (openedDropdown === idx) setOpenedDropdown(null);
        }
      });
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [openedDropdown]);

  const handleEdit = (row) => {
    setEditProductData(row);
    setShowEditModal(true);
    setOpenedDropdown(null);
  };

  const handleDelete = (id) => {
    console.log('Delete Product ID:', id);
  };

  return (
    <div className="ediits-container p-3">
      {showEditModal && (
        <EditProduct
          product={editProductData}
          onClose={() => setShowEditModal(false)}
        />
      )}

      {!showEditModal && (
        <>
          <div className="ediits-header">
            <div className="ediits-title">12th January of 2024, 12:00 pm</div>
            <div className="ediits-actions">
              <button className="ediits-btn blue">Add New Product</button>
              <button className="ediits-btn">Add New Service</button>
            </div>
          </div>

          <div className="ediits-filters">
            <button className="ediits-filter actives">24 Hour</button>
            <button className="ediits-filter">7 Days</button>
            <button className="ediits-filter">30 Days</button>
            <button className="ediits-filter">12 Months</button>
          <div className="search-wrapperr">
    <input
      type="text"
      placeholder="Search by order id"
      className="stock-search"
    />
    <i className="fa-solid fa-magnifying-glass search-icon"></i>
  </div>
            <button className="ediits-btn export">Export</button>
          </div>

          <div className="ediits-table-wrapper">
            <table className="ediits-table">
              <thead>
                <tr>
                  <th>Product ID</th>
                  <th>Product Name</th>
                  <th>Category</th>
                  <th>Quantity</th>
                  <th>Per.Price</th>
                  <th>Status</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {initialProducts.map((row, idx) => (
                  <tr key={idx}>
                    <td>{row.id}</td>
                    <td>{row.name}</td>
                    <td>{row.category}</td>
                    <td>{row.quantity}</td>
                    <td>{row.price}</td>
                    <td>
                      <span className={`ediits-status ${statusColors[row.status] || ''}`}>
                        {row.status}
                      </span>
                    </td>
                    <td>
                      <div
                        className="dots-wrapper"
                        ref={(el) => (dotsRefs.current[idx] = el)}
                      >
                        <button
                          className="dots-menu-btn"
                          onClick={() =>
                            setOpenedDropdown(openedDropdown === idx ? null : idx)
                          }
                        >
                          ⋯
                        </button>
                        {openedDropdown === idx && (
                          <div className="dropdown-menu">
                            <button onClick={() => handleEdit(row)}>
                              <FiEdit2 />
                              Edit
                            </button>
                            <button
                              className="delete"
                              onClick={() => handleDelete(row.id)}
                            >
                              <FiTrash2 />
                              Delete
                            </button>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="ediits-pagination">
            <span>Showing 1 to 10 of {initialProducts.length} results</span>
            <div className="page-numbers">
              <button className="active">1</button>
              <button>2</button>
              <button>3</button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
